import React, { ChangeEvent, FunctionComponent } from 'react';
import { FormControlLabel } from '@material-ui/core';
import { Checkbox } from '../common/Checkbox';

export interface CheckboxInputProps {
  className?: string;
  checked?: boolean;
  label: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  color?: 'primary' | 'secondary';
}

export const CheckboxInput: FunctionComponent<CheckboxInputProps> = ({
  className,
  checked,
  label,
  onChange,
  disabled = false,
  color = 'primary',
}) => {
  return (
    <div>
      <FormControlLabel
        control={
          <Checkbox
            checked={checked}
            onChange={onChange}
            disabled={disabled}
            color={color}
            className={className}
          />
        }
        label={label}
      />
    </div>
  );
};
